import { useState, useEffect } from "react";
import {
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import Localbase from "localbase";

let db = new Localbase("db");

// Register font
Font.register({
  family: "Poppins",
  src: "./assets/fonts/Poppins/Poppins-Regular.ttf",
});

const TestPDF = () => {
  db.collection("CardsDraw")
    .doc("drawPerfil")
    .get()
    .then((document) => {
      document && setDrawPerfil(document.testIMG);
    });

  db.collection("CardsDraw")
    .doc("drawFront")
    .get()
    .then((document) => {
      document && setDrawFront(document.testIMG);
    });

  const [drawPerfil, setDrawPerfil] = useState();
  const [drawFront, setDrawFront] = useState();

  const [imgPerfil, setImgPerfil] = useState();
  const [imgFrente, setImgFrente] = useState();
  const [img02, setImg02] = useState();
  const [img03, setImg03] = useState();
  const [img04, setImg04] = useState();
  const [img05, setImg05] = useState();
  const [img06, setImg06] = useState();
  const [img07, setImg07] = useState();
  const [img08, setImg08] = useState();
  const [img09, setImg09] = useState();
  const [img10, setImg10] = useState();

  // anamnesis 1.1
  const localMotivo = JSON.parse(localStorage.getItem("localMotivo"));
  const localDiagnostico = JSON.parse(localStorage.getItem("localDiagnostico"));
  const localEstudiosDiagnosticos = JSON.parse(
    localStorage.getItem("localEstudiosDiagnosticos")
  );
  const localMedicacion = JSON.parse(localStorage.getItem("localMedicacion"));
  // anamnesis 1.2
  const localOcupacion = JSON.parse(localStorage.getItem("localOcupacion"));
  const localDeportes = JSON.parse(localStorage.getItem("localDeportes"));
  const localTratamientosActuales = JSON.parse(
    localStorage.getItem("localTratamientosActuales")
  );
  const localOtroSintomas = JSON.parse(
    localStorage.getItem("localOtroSintomas")
  );
  // anamnesis 1.3
  const localCirugias = JSON.parse(localStorage.getItem("localCirugias"));
  const localPartos = JSON.parse(localStorage.getItem("localPartos"));
  const localAccidentes = JSON.parse(localStorage.getItem("localAccidentes"));
  const localAlimentacion = JSON.parse(
    localStorage.getItem("localAlimentacion")
  );

  // Dianostico por esferas
  /* let localMenuValue = ['cadena', 'cierre','apertura']; */
  
   const localMenuValue = JSON.parse(localStorage.getItem("localMenuValue"));

  // Conclusion diagnostica

  /*  */

  
  let arrPatronBase = null;

  let arrEsfera = null;
  let arrPda = null;
  let arrCadenaCausal = null;
  let arrCadenaReactiva = null;

  const localEsfera = JSON.parse(localStorage.getItem("localEsfera"));

  localEsfera && ( arrEsfera = Object.values(localEsfera)[0])
  
  

  const localPatronBase = JSON.parse(localStorage.getItem("localPatronBase"));
  localPatronBase && (arrPatronBase = Object.values(localPatronBase)[0]);

  

  // Razonamiento clínico

  const localSintoma = JSON.parse(localStorage.getItem("localSintoma"));

  const localPda = JSON.parse(localStorage.getItem("localPda"));
  localPda && (arrPda = Object.values(localPda)[0]);

  const localCadenaCausal = JSON.parse(
    localStorage.getItem("localCadenaCausal")
  );
  localCadenaCausal && (arrCadenaCausal = Object.values(localCadenaCausal)[0]);

  const localCadenaReactiva = JSON.parse(
    localStorage.getItem("localCadenaReactiva")
  );
  localCadenaReactiva && (arrCadenaReactiva = Object.values(localCadenaReactiva)[0]);

  const localPosturaCorrectiva = JSON.parse(
    localStorage.getItem("localPosturaCorrectiva")
  );
  const localPosturaGlobal = JSON.parse(
    localStorage.getItem("localPosturaGlobal")
  );

  useEffect(() => {
    // Get image from indexeddb to state imgPreview with lib Localbase
    db.collection("CardsPhotos")
      .doc("fileUpload0")
      .get()
      .then((document) => {
        document && setImgPerfil(document.image);
      });

    // Get image from indexeddb to state imgPreview with lib Localbase
    db.collection("CardsPhotos")
      .doc("fileUpload1")
      .get()
      .then((document) => {
        document && setImgFrente(document.image);
      });

    db.collection("CardsPhotos")
      .doc("fileUpload2")
      .get()
      .then((document) => {
        document && setImg02(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload3")
      .get()
      .then((document) => {
        document && setImg03(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload4")
      .get()
      .then((document) => {
        document && setImg04(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload5")
      .get()
      .then((document) => {
        document && setImg05(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload6")
      .get()
      .then((document) => {
        document && setImg06(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload7")
      .get()
      .then((document) => {
        document && setImg07(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload8")
      .get()
      .then((document) => {
        document && setImg08(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload9")
      .get()
      .then((document) => {
        document && setImg09(document.image);
      });
    db.collection("CardsPhotos")
      .doc("fileUpload10")
      .get()
      .then((document) => {
        document && setImg10(document.image);
      });

    // Get image Draw
    /* db.collection("CardsDraw")
      .doc("drawPerfil")
      .get()
      .then((document) => {
        document && setImgDraw(document.image);
      }); */
  });

  /*  const styles = StyleSheet.create({
    image: { width: "6.5cm", height: "9cm", borderRadius: "10px" },
    flexRow: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
    },
  }); */

  /* Fecha */
  const today = new Date();

  const date =
    today.getDate() +
    " / " +
    (today.getMonth() + 1) +
    " / " +
    today.getFullYear();

  /*  const tiempoTranscurrido = Date.now();
    const hoy = new Date(tiempoTranscurrido);
    const hoyLegible = hoy.toLocaleDateString(); // "Sun Jun 14 2020" */

  /* *** */

  const styles = StyleSheet.create({
    logo: { width: "18%", marginLeft: "1%" /*  height: "58px" */ },
    section1: { height: "40%" /* backgroundColor: "green"  */ },
    section2: { height: "40%" /* backgroundColor: "pink" */ },
    titleSection1: {
      fontFamily: "Poppins",
      fontSize: "16",
      textAlign: "center",
      marginBottom: "3%",
    },
    titleSection2: {
      fontFamily: "Poppins",
      fontSize: "16",
      textAlign: "center",
      margin: "3%",
    },
    titleCard: {
      fontFamily: "Poppins",
      fontSize: "14",
      textAlign: "center",
      marginTop: "3%",
      marginBottom: "3%",
    },
    titleCard1: {
      position: "absolute",
      top: "5%",
      left: "2cm",
      /* margin: "0 auto", */
      fontFamily: "Poppins",
      fontSize: "14",
      textAlign: "center",
      /* marginTop: "3%", */
      marginBottom: "3%",
    },
    titlePhoto: {
      fontFamily: "Poppins",
      fontSize: "14",
      textAlign: "center",
      marginTop: "5%",
      marginBottom: "5%",
    },
    titleForm: {
      fontFamily: "Poppins",
      color: "grey",
      fontSize: "12",
      /* textAlign: "center", */
      margin: "1%",
    },
    titleForm1: {
      /* position: "relative",
      top: "3%", */
      fontFamily: "Poppins",
      color: "grey",
      fontSize: "12",
      /* textAlign: "center", */
      marginTop: "3c%",

      marginLeft: "3%",
    },
    titleForm2: {
      fontFamily: "Poppins",
      color: "grey",
      fontSize: "12",
      /* textAlign: "center", */
      margin: "1%",
      marginLeft: "3%",
    },
    textForm: {
      fontFamily: "Poppins",
      fontSize: "12",
      /* color:'grey', */
      minHeight: "5%",
      /* textAlign: "center", */
      /* margin: "1%", */
      /* backgroundColor:'pink', */
      borderRadius: "5px",
      border: "0.5px",
      /* borderColor: "#ff7d02", */
      borderColor: "#00b0a5;",
      padding: "1%",
    },
    textForm1: {
      fontFamily: "Poppins",
      fontSize: "12",
      /* color:'grey', */
      minHeight: "17%",
      /* textAlign: "center", */
      /* margin: "1%", */
      /* backgroundColor:'pink', */
      borderRadius: "5px",
      border: "0.5px",
      /* borderColor: "#ff7d02", */
      borderColor: "#00b0a5;",
      padding: "1%",
      marginLeft: "3%",
      marginRight: "3%",
    },
    textForm2: {
      fontFamily: "Poppins",
      fontSize: "12",
      marginBottom: "3%",
      minHeight: "5%",
      borderRadius: "5px",
      border: "0.5px",
      borderColor: "#00b0a5;",
      padding: "1%",
    },
    wraperCards: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
    },
    wraperCards1: {
      display: "flex",
      flexDirection: "row",
      width: "6.5cm",
      justifyContent: "center",
    },
    cardSection: {
      width: "6.5cm",
      height: "9.5cm",
      borderRadius: "10px",
      border: "1px",
      borderColor: "#ff7d02",
      padding: "1%",
      /* paddingTop: "3%", */
    },
    cardSection1: {
      display: "flex",
      /* flexDirection: "row", */
      /* alignItems: "center", */
      justifyContent: "center",
      width: "6.5cm",
      height: "9.5cm",
      borderRadius: "10px",
      border: "1px",
      borderColor: "#ff7d02",
      padding: "1%",
    },
    cardSection3: {
      paddingTop: "3%",
      width: "6.5cm",
      height: "9.5cm",
      borderRadius: "10px",
      border: "1px",
      borderColor: "#ff7d02",
      padding: "1%",
      /* paddingTop: "3%", */
    },
    cardPhoto: {
      width: "6.5cm",
      minHeight: "11.5cm",
      /* borderRadius: "10px", */
      /* border: "1px",
      borderColor: "#ff7d02",
      padding: "1%", */
    },
    image: { width: "6.5cm", height: "9.5cm", borderRadius: "10px" },
    footer: {
      display: "flex",
      /* alignSelf:"flex-end", */ /* backgroundColor: "yellow", */
      width: "100%",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "1%",
      position: "absolute",
      bottom: "0",
    },
    textFooter: { fontFamily: "Poppins", color: "grey", fontSize: "12" },
    numbPage: {},
    draw: {
      position: "absolute",
      /* left: "-6.5cm", */
      zIndex: "-1",
      width: "6.5cm",
      /* backgroundColor: 'tomato', "./assets/images/cmf-logo.png",
      backgroundSize: "contain ",
      backgroundRepeat: "no-repeat", */
    },
    draw1: {
      /* position: "relative", */
      /* left: "-6.5cm", */
      zIndex: "1",
      width: "6.5cm",
      /* backgroundColor: 'tomato', "./assets/images/cmf-logo.png",
      backgroundSize: "contain ",
      backgroundRepeat: "no-repeat", */
    },
  });

  /* let motivo = histoClinica.motivoConsulta */

  return (
    <>
      <Document>
        {/* Test Page layout */}
        <Page size="A4">
          <Image src={"./assets/images/cmf-logo.png"} style={styles.logo} />

          <View style={styles.section1}>
            <Text style={styles.titleSection1}>Historia Clínica</Text>

            <View style={styles.wraperCards}>
              {/* Anamnesis 1.1 */}
              <View style={styles.cardSection}>
                <Text style={styles.titleCard}>Anamnesis 1.1</Text>
                <Text style={styles.titleForm}>Motivo de consulta</Text>
                {/* <View style={styles.textForm}>
                  
                </View> */}
                <Text style={styles.textForm}>{localMotivo}</Text>

                <Text style={styles.titleForm}>Diagnóstico médico</Text>
                <Text style={styles.textForm}>{localDiagnostico}</Text>
                <Text style={styles.titleForm}>Estudios diagnósticos</Text>
                <Text style={styles.textForm}>{localEstudiosDiagnosticos}</Text>
                <Text style={styles.titleForm}>Medicación</Text>
                <Text style={styles.textForm}>{localMedicacion}</Text>
              </View>

              {/* Anamnesis 1.2 */}

              <View style={styles.cardSection}>
                <Text style={styles.titleCard}>Anamnesis 1.2</Text>
                <Text style={styles.titleForm}>Ocupación</Text>
                <Text style={styles.textForm}>{localOcupacion}</Text>

                <Text style={styles.titleForm}>Actividad física</Text>
                <Text style={styles.textForm}>{localDeportes}</Text>
                <Text style={styles.titleForm}>Tratamientos</Text>
                {/* <Text style={styles.textForm}>{ localTratamientosActuales }</Text> */}
                <Text style={styles.textForm}>{localTratamientosActuales}</Text>
                <Text style={styles.titleForm}>Otros síntomas</Text>
                <Text style={styles.textForm}>{localOtroSintomas}</Text>
              </View>
              {/* Anamnesis 1.3 */}
              <View style={styles.cardSection}>
                <Text style={styles.titleCard}>Anamnesis 1.3</Text>
                <Text style={styles.titleForm}>Cirugías</Text>
                <Text style={styles.textForm}>{localCirugias}</Text>
                <Text style={styles.titleForm}>Partos</Text>
                <Text style={styles.textForm}>{localPartos}</Text>
                <Text style={styles.titleForm}>Traumatismos</Text>
                <Text style={styles.textForm}>{localAccidentes}</Text>
                <Text style={styles.titleForm}>Alimentación</Text>
                <Text style={styles.textForm}>{localAlimentacion}</Text>
              </View>
            </View>
          </View>

          <View style={styles.section2}>
            <Text style={styles.titleSection2}>Evaluación de Perfil</Text>

            <View style={styles.wraperCards}>
              <View style={styles.cardSection1}>
                <Text style={styles.titleCard1}>Observar</Text>
                <Text style={styles.titleForm}>-Relación esferas</Text>
                <Text style={styles.titleForm}>-PdA++</Text>
                <Text style={styles.titleForm}>-Patrones posturales</Text>
                <Text style={styles.titleForm}>-Huellas de las cadenas</Text>
              </View>
              {imgPerfil? <Image src={imgPerfil} style={styles.image} /> : <View style={styles.cardSection1}><Text style={styles.titleCard}>Suba fotografía de perfil</Text></View>  }



              <View style={styles.wraperCards1}>
                <Image src={`${drawPerfil}`} style={styles.draw} />
                <Image
                  src={"./assets/images/card-perfil.png"}
                  style={styles.draw1}
                />
              </View>

              {/* <Image
                src={"./assets/images/card-perfil.png"}
                style={styles.image}
              /> */}
              {/* <Image src={ img } style={styles.image} /> */}
              {/* <Image src={ imgDraw } style={styles.image} /> */}
            </View>
          </View>

          <View style={styles.footer}>
            <Text style={styles.textFooter}>{date}</Text>
            <Text style={styles.textFooter}>www.kinesica.es</Text>
            <Text style={styles.textFooter}> Pág 1/4</Text>
          </View>
        </Page>

        {/* 2 page : Evaluacion de frente y resultados*/}
        <Page size="A4">
          <Image src={"./assets/images/cmf-logo.png"} style={styles.logo} />

          <View style={styles.section1}>
            <Text style={styles.titleSection1}>Evaluación de Frente</Text>

            <View style={styles.wraperCards}>
              <View style={styles.cardSection1}>
                <Text style={styles.titleCard1}>Observar</Text>
                <Text style={styles.titleForm}>-Cráneo, clavículas</Text>
                <Text style={styles.titleForm}>-Charpy</Text>
                <Text style={styles.titleForm}>-Abdomen</Text>
                <Text style={styles.titleForm}>-Rodillas</Text>
                <Text style={styles.titleForm}>
                  -Asimetrías no fisiológicas
                </Text>
              </View>
              {imgFrente? <Image src={imgFrente} style={styles.image} /> : <View style={styles.cardSection1}><Text style={styles.titleCard}>Suba fotografía de frente</Text></View>  }
              <View style={styles.wraperCards1}>
                <Image src={`${drawFront}`} style={styles.draw} />
                <Image
                  src={"./assets/images/front-card-traced.png"}
                  style={styles.draw1}
                />
              </View>
              {/* <Image
                src={`${testIMG}`}
                style={ styles.draw }
              /> */}

              {/* <Image src={img} style={styles.image} /> */}
              {/* <Image src={imgDraw} style={styles.image} /> */}
            </View>
          </View>

          <View style={styles.section2}>
            <Text style={styles.titleSection2}>Resultados</Text>

            <View style={styles.wraperCards}>
              {/* Dianostico por esferas */}
              <View style={styles.cardSection}>
                <Text style={styles.titleCard}> Dianóstico por esferas</Text>
                <Text style={styles.titleForm}>Esfera PdA++ Cadena</Text>

                { localMenuValue && (
                  <Text style={styles.textForm2}>{localMenuValue[0]}</Text>
                )}
                {localMenuValue && (
                  <Text style={styles.textForm2}>{localMenuValue[1]}</Text>
                )}
                {localMenuValue && (
                  <Text style={styles.textForm2}>{localMenuValue[2]}</Text>
                )}
                {localMenuValue && (
                  <Text style={styles.textForm2}>{localMenuValue[3]}</Text>
                )}
              </View>

              {/* Conclusion diagnostica */}

              <View style={styles.cardSection}>
                <Text style={styles.titleCard}>Conclusión Diagnóstica</Text>
                <Text style={styles.titleForm}>Esferas++</Text>
               
                 <Text style={styles.textForm}>{ arrEsfera } </Text> 
                <Text style={styles.titleForm}>Cadena o Patrón de Base</Text>
               
                <Text style={styles.textForm}>{ arrPatronBase } </Text>
                
              </View>

              {/* Razonamiento clínico */}
              <View style={styles.cardSection}>
                <Text style={styles.titleCard}>Razonamiento Clínico</Text>
                <Text style={styles.titleForm}>Síntoma</Text>
                <Text style={styles.textForm}>{localSintoma}</Text>
                <Text style={styles.titleForm}>PdA++</Text>
                <Text style={styles.textForm}>{arrPda}</Text>
                <Text style={styles.titleForm}>Cadena Causal</Text>
                <Text style={styles.textForm}>{arrCadenaCausal}</Text>
                <Text style={styles.titleForm}>Cadena Reactiva</Text>
                <Text style={styles.textForm}>{arrCadenaReactiva}</Text>
              </View>
            </View>
          </View>

          <View style={styles.footer}>
            <Text style={styles.textFooter}>{date}</Text>
            <Text style={styles.textFooter}>www.kinesica.es</Text>
            <Text style={styles.textFooter}> Pág 2/4</Text>
          </View>
        </Page>

        {/* 3 page Plan Correctivo */}

        <Page size="A4">
          <Image src={"./assets/images/cmf-logo.png"} style={styles.logo} />

          <View style={styles.section1}>
            <View style={styles.wraperCards}>
              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>Plan Correctivo</Text>
                <View style={styles.cardSection3}>
                  {/* <Text style={styles.titleCard}> </Text> */}

                  <Text style={styles.titleForm1}>Postura Correctiva</Text>
                  <Text style={styles.textForm1}>{localPosturaCorrectiva}</Text>

                  <Text style={styles.titleForm2}>Postura Global</Text>
                  <Text style={styles.textForm1}>{localPosturaGlobal}</Text>
                </View>
              </View>

              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>Postura Correctiva</Text>
                {img09 && <Image src={img09} style={styles.image} />}
              </View>

              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}> Postura Global </Text>
                {img10 && <Image src={img10} style={styles.image} />}
              </View>
            </View>
          </View>

          <View style={styles.section2}>
            <View style={styles.wraperCards}>
              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>Posterior</Text>
                {img02 && <Image src={img02} style={styles.image} />}
              </View>

              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}> Test de Flexión </Text>
                {img03 && <Image src={img03} style={styles.image} />}
              </View>
              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}> Test de Antebáscula </Text>
                {img04 && <Image src={img04} style={styles.image} />}
              </View>
            </View>
          </View>
          <View style={styles.footer}>
            <Text style={styles.textFooter}>{date}</Text>
            <Text style={styles.textFooter}>www.kinesica.es</Text>
            <Text style={styles.textFooter}> Pág 3/4</Text>
          </View>
        </Page>

        {/* page 4 */}
        <Page size="A4">
          <Image src={"./assets/images/cmf-logo.png"} style={styles.logo} />

          <View style={styles.section1}>
            <View style={styles.wraperCards}>
              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>Test de Retrobáscula</Text>
                {img05 && <Image src={img05} style={styles.image} />}
              </View>

              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>Decubito Supino (EIAS)</Text>
                {img06 && <Image src={img06} style={styles.image} />}
              </View>

              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}> Largo de Pierna </Text>
                {img07 && <Image src={img07} style={styles.image} />}
              </View>
            </View>
          </View>

          <View style={styles.section2}>
            <View style={styles.wraperCards}>
              <View style={styles.cardPhoto}>
                <Text style={styles.titlePhoto}>
                  Decubito Prono (Isquiones)
                </Text>
                {img08 && <Image src={img08} style={styles.image} />}
              </View>
            </View>
          </View>
          <View style={styles.footer}>
            <Text style={styles.textFooter}>{date}</Text>
            <Text style={styles.textFooter}>www.kinesica.es</Text>
            <Text style={styles.textFooter}> Pág 4/4</Text>
          </View>
        </Page>
      </Document>
    </>
  );
};

export default TestPDF;
